import formHelper from 'formhelper';
import Cookies from 'cookies-js';
import $ from 'jquery';
import dialogEvents from '../l-dialog-events';

const cookieName = 'cs_postloginpath';


formHelper.addRule({
  form: '#register-account',
  status: {
      SUCCESS() {
          const postLoginPath = Cookies.get(cookieName) || '/my-account';
          Cookies.expire(cookieName);
          this.redirect(postLoginPath);
      }
  }
  });


formHelper.addRule({
  form: '#login-account',
  status: {
    SUCCESS() {
      const postLoginPath = Cookies.get(cookieName) || '/my-account';
      Cookies.expire(cookieName);
      this.redirect(postLoginPath);
    },
    TEMP_LOGIN: '/my-account/change-password'
  }
});

function initCountrySelects() {
  $('.js-select-country').on('change', event => {

    const $country = $(event.target);
    const $states = $country.parents('.js-address-container').find('.js-select-state');
    const country = $country.val();

    $states.attr('disabled', 'disabled');
    $states.html('<option>Loading...</option>');

    $.post('/h/account/GetCountryStateOptions', { country }, data => {
      $states.html(data);
      window.setTimeout(_ => {
        if ($states[0].options.length > 1) {
          $states.prop('disabled', false);
          $states.prop('required', true);
          $states[0].focus();
        } else {
          $states.prop('required', false);
        }
      }, 1);
    });

  });
}

$(initCountrySelects);

dialogEvents.set('account-country-selects', initCountrySelects);